import {CountryActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const CountryRequestInit = () => {
    return {
        type:CountryActionType.Country_INIT
    }
}

export const CountrySuccess = (
    objeckt: any
) => {
    return {
        type: CountryActionType.Country_INIT,
        objeckt: objeckt
    }
}

export const getCountry = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            CountrySuccess(
                objeckt
            )
        )
    }
}
